import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  user: '',
  total_pages: 0,
  total_results: 0
};
export const useUserFetch = id => {
  const auth = useAuth();
  const [userstate, usersetState] = useState(initialState);
  const [userloading, usersetLoading] = useState(false);
  const [usererror, usersetError] = useState(false);
  const [usertrigger, usersetTrigger] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use Employee fetch")
  console.log(id)
  useEffect(()=>{
    console.log("binne use Employee fetch se useEffect")
    const fetchUser = async()=>{
      try {
        usersetLoading(true);
        usersetError(false);
       usersetTrigger(false)
        const user = await API.fetchUser(id,accessToken)
       
        console.log(user)
        usersetState({  
          ...user.user[0]
          
        }
        )

        usersetLoading(false)

      } catch (error) {
        console.log(error)
        usersetError(true);
      }
    }
    fetchUser()
  },[id,usertrigger]);

return{userstate,userloading,usererror,usersetLoading,usersetTrigger};


};
